import { ReactNode } from "react";
import OptimizedHeroImage from "./OptimizedHeroImage";

interface HeroSectionProps {
  imageSrc: string;
  imageAlt: string;
  children: ReactNode;
  height?: string;
  overlayGradient?: string;
  priority?: boolean;
}

/**
 * HeroSection Component
 * Reusable hero section with optimized background image
 * Implements best practices for Core Web Vitals:
 * - Preloading for LCP optimization
 * - Fixed aspect ratio to prevent CLS
 * - Lazy loading for non-priority heroes
 */
const HeroSection = ({
  imageSrc,
  imageAlt,
  children,
  height = "600px",
  overlayGradient = "bg-gradient-to-r from-primary-dark/98 via-primary/95 to-primary-dark/98",
  priority = true,
}: HeroSectionProps) => {
  return (
    <section 
      className="relative flex items-center overflow-hidden"
      style={{ minHeight: height }}
    >
      {/* Optimized Background Image */}
      <div className="absolute inset-0">
        <OptimizedHeroImage
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full"
          priority={priority}
          aspectRatio="auto"
        />
        {/* Gradient Overlay */}
        <div className={`absolute inset-0 ${overlayGradient}`} />
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        {children}
      </div>
    </section>
  );
};

export default HeroSection;
